





















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { inject } from 'inversify-props';
import { IUserService, UserType, IInvitationService } from '@/interfaces/Services';
import { DoctorModel } from '@/models/doctor';
import { UserModel } from '@/models/user';
import LambdaDownloader from '@/utils/lambda_downloader';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

type InvitationResult = {
  model: DoctorModel;
  err?: Error;
  result?: UserModel;
};

@Component({})
export class DoctorInvitationModal extends Vue {
  @inject(DependencyIdentifiers.InvitationService)
  private invitationService!: IInvitationService;

  @Prop({ required: true })
  doctors!: DoctorModel[];

  private componentKey = 0;
  private current: InvitationResult | null = null;
  private results: InvitationResult[] = [];

  private get progress() {
    if (this.doctors.length === 0) {
      return 100;
    }
    return (this.results.length / this.doctors.length) * 100;
  }

  private get remaining() {
    return this.doctors.length - this.results.length;
  }

  async mounted() {
    const doctors = [...this.doctors];
    for (let i = 0; i < doctors.length; i++) {
      const result: InvitationResult = { model: { ...doctors[i] } };
      this.current = result;
      this.componentKey++;
      await new Promise(resolve => setTimeout(resolve, 1500));
      try {
        result.result = await this.invitationService.create({
          type: UserType.Doctors,
          name: result.model.name,
          email: result.model.contactEmail,
          $doctorId: result.model.$id as string,
          $centerId: result.model.$centerId as string,
        });
        this.onInvitationSuccess(result);
      } catch (err) {
        result.err = err;
        this.onInvitationFailure(result);
      } finally {
        this.current = null;
      }
      this.results = [result, ...this.results];
    }
    this.onComplete(this.results);
  }

  @Emit("complete")
  onComplete(result: InvitationResult[]) {
    return result;
  }

  @Emit("invitation:success")
  onInvitationSuccess(result: InvitationResult) {
    this.onInvitation(result);
    return result;
  }

  @Emit("invitation:failure")
  onInvitationFailure(result: InvitationResult) {
    this.onInvitation(result);
    return result;
  }

  @Emit("invitation")
  onInvitation(result: InvitationResult) {
    this.componentKey++;
    return result;
  }

  async downloadRecoveryKey(email: string, recoveryKey: string) {
    const download = new LambdaDownloader(
      {key: recoveryKey, email},
      `recovery-key-to-pdf`,
      `hemonaplo-recovery-${email}`
    );
    await download.start();
  }
}

export default DoctorInvitationModal;
